import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/common/hooks/useAuth'
import { AdminNav } from '@/common/components/admin-nav/AdminNav'

export const Route = createFileRoute('/org')({
  component: AdminLayout,
})

function AdminLayout() {
  const { isAuthenticated, isLoading, user } = useAuth()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Loading...
      </div>
    )
  }

  if (!isAuthenticated || !user?.roles?.includes('admin')) {
    return <Navigate to="/" replace />
  }

  return (
    <div>
      <AdminNav />
      <main>
        <Outlet />
      </main>
    </div>
  )
}
